import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function BreadCrumbsContainer(props) {
  const [breadCrumbs, setBreadCrumbs] = useState(props.breadCrumbs)
  const [containerObject, setContainerObject] = useState(props.containerObject)
  const [showModal, setShowModal] = useState(false)
  const [pdpData, setpdpData] = useState(props.pdpData)
  const [screenWidth, setScreenWidth] = useState("")

  const showSharePageModal = (e) => {
    e.preventDefault();
  }
  const showFoundAndErrorModal = (e) => {
    e.preventDefault();
  }

  const printPage = (e) => {
    e.preventDefault("description-container");
    var printContents = document.getElementById("description-container").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    location.reload();
  }

  useEffect(() => {
    setScreenWidth(screen.width)
  }, [])


  const handlePrintOnlyPage = () => {
    var printContents = document.getElementById("print-area").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    location.reload();
  }

  return (
    <div data-cont-id={props.containerObject ? props.containerObject.contentId : ""} data-zone={props.dataZone ? props.dataZone : ""} data-page-id={props.contentId ? props.contentId : ""} data-template-name={props.templateName ? props.templateName : ""} className={`row container-fluid vast-plugin-content gx-0 ${containerObject ? "px-1 pb-0" : "p-0"}`}>
      <div className="row gx-0">
        <div className="col-12">
          <nav aria-label="breadcrumb" style={{display:"flex"}}>
            <ol class={`c-breadcrumb breadcrumb breadCrumbFontSize col-md-11 mb-0 ${containerObject && containerObject.attributes && containerObject.attributes.className ? containerObject.attributes.className : containerObject ? "breadCrumbCss" : ""}`}>
              {breadCrumbs ?
                <>
                  <li className="breadcrumb-item">
                    <Link sample="aabreadCrumbs" to="/">Home</Link>
                  </li>
                  {breadCrumbs.ancestors ? Object.entries(breadCrumbs.ancestors).map(([key, value], keyIndex) => {
                    return (
                      <li className="breadcrumb-item">
                        <Link sample="aaaaaa" to={value.link} dangerouslySetInnerHTML={{__html: value.label}}></Link>
                      </li>
                    )
                  }) : ""}
                  {breadCrumbs.productName ?
                    <li class="breadcrumb-item active" dangerouslySetInnerHTML={{__html: breadCrumbs.productName}}></li>
                    : ""}
                  {breadCrumbs && breadCrumbs.label ?
                    <li class="breadcrumb-item active" dangerouslySetInnerHTML={{__html: breadCrumbs.label }}></li>
                    : ""}
                </> :
                containerObject ?
                  <> {props.containerObject && props.containerObject.displayPluginContent === false ? "" :
                    <>
                      <li className="breadcrumb-item">
                        <Link sample="aacontainerObject" to="/">Home</Link>
                      </li>
                      {containerObject.breadCrumb && containerObject.breadCrumb.ancestors ? containerObject.breadCrumb.ancestors.map(value => {
                        return (
                          <li class="breadcrumb-item">
                            <Link to={value.link} dangerouslySetInnerHTML={{__html: value.label}}></Link>
                          </li>
                        )
                      }) : ""}
                      {containerObject.breadCrumb && containerObject.breadCrumb.label ?
                        <li class="breadcrumb-item active" dangerouslySetInnerHTML={{__html: containerObject.breadCrumb.label}}></li>
                        : ""}

                    </>}</>
                  : ""}
            </ol>
            {props.containerObject && props.containerObject.attributes && props.containerObject.attributes.displayPrintBtn && props.containerObject.attributes.displayPrintBtn === "true"  || props.displayPrintBtn == "true" ?
              <div className="col-1">
                <div className="col-12 col-md-1 d-none d-lg-block">
                  <button className="btn btn-light c-print-btn text-end" type="button" onClick={() => window.print()} >
                    <i className="bi bi-printer-fill" aria-hidden="true"></i>Print
                  </button>
                </div>
              </div> : ""}
          </nav>
        </div>


        {props.pageType && props.pageType == "PDP" ?
          <div className="col-md-4 col-12 d-none  d-sm-block default-cursor  text-right page-tools-cover">
            <ul className="page-tools li">
              <li>
                <Link id="hiddenFoundAndErrorModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#foundAndErrorModal" className="" onClick={showFoundAndErrorModal}>
                  <i className="fa fa-exclamation-triangle gold-color"></i>&nbsp;<span>Found An Error?</span>
                </Link>
              </li>
              <li>
                <Link id="hiddenSharePageModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#sharePageModal" onClick={showSharePageModal} className="">
                  <i className="fa fa-envelope"></i>&nbsp;<span>Share</span>
                </Link>
              </li>
              <input type="hidden" value="true" id="transient" wfd-invisible="true" />
              <li>
                <Link className="action" onClick={printPage}>
                  <i className="fa fa-print"></i>&nbsp;<span>Print</span>
                </Link>
              </li>
            </ul>
          </div>
          : ""}
        {props.pageType && props.pageType == "printOnly" ?
          <div className="col-md-4 col-12 d-none  d-sm-block default-cursor ">
            <ul className="page-tools li d-flex justify-content-end">
              <li>
                <Link className="action" onClick={handlePrintOnlyPage}>
                  <i className="fa fa-print"></i>&nbsp;<span>Print</span>
                </Link>
              </li>
            </ul>
          </div>
          : ""}
        {props.pageType && props.pageType == "shareOnly" ?
          <div className="col-md-4 col-12 d-none  d-sm-block default-cursor ">
            <ul className="page-tools li d-flex justify-content-end">
              <li>
                <Link id="hiddenSharePageModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#sharePageModal" onClick={showSharePageModal} className="">
                  <i className="fa fa-envelope"></i>&nbsp;<span>Share</span>
                </Link>
              </li>
            </ul>
          </div>
          : ""}
      </div>
      {containerObject && containerObject.attributes && containerObject.attributes.isPlpPage && containerObject.attributes.isPlpPage == "Y" && screenWidth < 768 ?
        <h2 className="d-none"><strong>{containerObject.breadcrumb && containerObject.breadcrumb.label ? containerObject.breadcrumb.label : ""}</strong></h2> : ""}
    </div >
  );
}

export default BreadCrumbsContainer;

